import styled from "styled-components/macro"

function Development({ children }) {
  return <Wrapper>{children}</Wrapper>
}

export default Development

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--primary);

  .pdf-document {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pdf-page {
    width: auto;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pdf-page-controls {
    position: fixed;
    left: 0;
    margin: 4rem 5.25rem;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;

    div {
      border-radius: 5px;
      background-color: var(--secondary) !important;
    }
    
    .border{
      border: 1px solid white;
    }
  }
`
